/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacy } from 'app/shared/model/pharmacy.model';
import { PharmacyIndentStatus } from 'app/shared/model/enumerations/pharmacy-indent-status.model';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';
import { PharmacyIndentType } from 'app/shared/model/enumerations/pharmacy-indent-type.model';

export interface IPharmacyStockIndent {
  id?: string;
  indentStatus?: keyof typeof PharmacyIndentStatus | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  addedById?: string | null;
  modifiedById?: string | null;
  fulfilledById?: string | null;
  pharmacyAddedByType?: keyof typeof PharmacyAddedByType | null;
  modifiedByType?: keyof typeof PharmacyAddedByType | null;
  fulfilledByType?: keyof typeof PharmacyAddedByType | null;
  indentFor?: keyof typeof PharmacyIndentType | null;
  indentNumber?: string;
  requestingPharmacy?: IPharmacy;
  fulfillingPharmacy?: IPharmacy;
}

export const defaultValue: Readonly<IPharmacyStockIndent> = {
  active: false,
};
